const white = {
  primary: '#FFF',
  hover: '#F8FAFC',
};

const black = {
  primary: '#333333',
};

const muted = {
  primary: '#858C94',
};

const gray = {
  primary: '#9DA5B0',
};

const border = {
  primary: '#E5EAF0',
};

const red = {
  primary: '#FF5252',
};

const brown = {
  primary: '#9B6426',
};

const periwinkle = {
  primary: '#EFF1FC',
};

export const colors = {
  red,
  gray,
  brown,
  white,
  muted,
  black,
  border,
  periwinkle,
};
